module.exports = __webpack_public_path__ + "img/14-1_02.13286d7a.jpg";